import React from 'react';

const ScrollIndicator = () => (
  <div className="scroll-indicator" />
);

export default ScrollIndicator;
